import { render, staticRenderFns } from "./your-library-genres.vue?vue&type=template&id=24312b36&scoped=true"
import script from "./your-library-genres.vue?vue&type=script&lang=js"
export * from "./your-library-genres.vue?vue&type=script&lang=js"
import style0 from "./your-library-genres.vue?vue&type=style&index=0&id=24312b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24312b36",
  null
  
)

export default component.exports